const NOTIFICATION_ADD = 'notifications/add'
const NOTIFICATION_REMOVE = 'notifications/remove'

const initialState = []

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION_ADD:
      return [action.payload, ...state]
    case NOTIFICATION_REMOVE:
      return state.filter(notification => notification.id !== action.payload)
    default:
      return state
  }
}

export function addNotification(notification) {
  return {
    type: NOTIFICATION_ADD,
    payload: { ...notification, id: notification.id || Math.random().toString(36) },
  }
}

export function removeNotification(notificationId) {
  return {
    type: NOTIFICATION_REMOVE,
    payload: notificationId,
  }
}

export const notify = (message, dismissAfterSeconds = 5) => dispatch => {
  const {
    payload: { id },
  } = dispatch(addNotification(typeof message === 'object' ? message : { message }))

  return new Promise(resolve => {
    setTimeout(() => resolve(dispatch(removeNotification(id))), dismissAfterSeconds * 1000)
  })
}
